import { render, staticRenderFns } from "./TnumItemList.vue?vue&type=template&id=637e6df2"
import script from "./TnumItemList.vue?vue&type=script&lang=js"
export * from "./TnumItemList.vue?vue&type=script&lang=js"
import style0 from "./TnumItemList.vue?vue&type=style&index=0&id=637e6df2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports